//
// const request = require('superagent-bluebird-promise');
// const cacheModuleConfig = { defaultExpiration: 60 };
// require('superagent-cache')(request, cacheModuleConfig);
// module.exports = request;

import request from 'superagent-bluebird-promise';
import SuperAgentCache from 'superagent-cache';
import cacheModule from './index';

const cacheModuleConfig = { defaultExpiration: 60 };

export default (function () {
    if (process.browser) {
        SuperAgentCache(request, cacheModuleConfig);
        return request;
    }
    SuperAgentCache(request, cacheModule);
    return request;
})();



// WEBPACK FOOTER //
// ./app/lib/api/cache/requestCache.js